export default __webpack_public_path__ + "static/media/Chisel.7f9697e0.png";